/**
 * Composant de base pour créer des modals
 */
export class HuitabModal {
  /**
   * Initialise une instance de type {@type HuitabModal}
   * @param {string} id id HTML de la modal
   */
  constructor(id) {
    /**
     * Référence vers l'élément \<lnc-web-modal\>
     */
    this.element = document.getElementById(id);

    this.element?.addEventListener('instance', (event) => {
      this.modalRef = event.detail;
    });

    /**
     * Gestion du contour afin qu'il ne soit présent que lorsque l'utilisateur utilise le clavier pour naviguer.
     */
    HuitabModal._keyboardNavInitialized = false;

    if (!HuitabModal._keyboardNavInitialized) {
      HuitabModal._keyboardNavInitialized = true;

      function handleFirstTab(e) {
        if (e.key === "Tab") {
          document.body.classList.add("user-is-tabbing");
          window.removeEventListener("keydown", handleFirstTab);
          window.addEventListener("mousedown", handleMouseDownOnce);
        }
      }

      function handleMouseDownOnce() {
        document.body.classList.remove("user-is-tabbing");
        window.removeEventListener("mousedown", handleMouseDownOnce);
        window.addEventListener("keydown", handleFirstTab);
      }

      window.addEventListener("keydown", handleFirstTab);

      const style = document.createElement("style");
      style.textContent = `
        lnc-web-modal lnc-icon button {
          outline: none !important;
        }
        .user-is-tabbing lnc-web-modal lnc-icon button:focus {
          outline: 2px solid #4d59ef !important;
          outline-offset: 2px !important;
        }

        @media (min-width: 768px)  {
          #modal-supprimer-interlocuteur .lnc-modal-content > div:nth-child(2).tablet\\:row.h-space-between {
            justify-content: flex-end !important;
          }
        }

        @media (max-width: 768px)  {
          lnc-web-button[leftButton] {
            order: 2;
          }

          lnc-web-button[rightButton] {
            order: 1;
          }
        }

        #modal-supprimer-interlocuteur {
            .lnc-modal-container {
              width: 794px;
              padding: 16px;
            }

            lnc-web-button > button {
              flex-grow: 0;
              white-space: normal;
            }

            #modal-title.bold.lnc-text-1 { 
              font-weight: 400 !important; 
              font-size: 1.5rem !important; 
            }

            .horizontal-line {
              height: 0px !important;
            }

            div.lnc-modal-content lnc-web-button > button{
              font-weight: 500 !important;
            }
        }
      `;
      document.head.appendChild(style);
    }
  }

  /**
   * Définit la callback appelée lors de la fermeture de la modal (clic sur la croix de fermeture ou leftButton)
   * @param {() => {}} callback appelée lors de l'événement dismiss
   */
  onDismiss(callback) {
    this.element?.addEventListener('dismiss', callback.bind(this));
  }

  /**
   * Définit la callback appelée lors de la fermeture de la modal (clic sur rightButton)
   * @param {() => {}} callback appelée lors de l'événement accept
   */
  onAccept(callback) {
    this.element?.addEventListener('accept', callback.bind(this));
  }

  /**
   * Affiche la modal
   */
  show() {
    this.modalRef?.show();
  }

  /**
   * Cacher la modal avec émission d'un événement dismiss
   */
  hideOnDismiss() {
    this.modalRef?.hideOnDismiss();
  }

  /**
   * Fermeture de la modal avec émission d'un événement accept
   */
  hideOnAccept() {
    this.modalRef?.hideOnAccept();
  }
}
